<br />
<div class="energy-consumption-header" fxLayout="row wrap" fxFlex="100%;">
  <div
    class="row-wrap"
    fxLayout="row wrap"
    fxFlex="100%;"
    fxLayout.xs="row wrap"
  >
    <div
      class="dashboard-wrapper energy-consumption-container"
      fxLayout="row wrap"
      fxFlex="39.5%;"
      fxFlex.xs="100%;"
      fxFlex.lt-xl="100%;"
    >
      <div
        class="header-title header-title-hover"
        id="energy-consumption"
        fxFlex="90%;"
        fxLayoutAlign="left center"
        (click)="onEnergyTrendClick()"
      >
        {{ 'energy.dashboard.energyConsump' | translate }}
      </div>
      <button
        class="info-box"
        matTooltip="{{ energyConsumptionTooltip }}"
        matTooltipShowDelay="500"
        matTooltipPosition="right"
        aria-label="{{ energyConsumptionTooltip }}"
      >
        i
      </button>
      <div
        class="chart-container"
        fxLayout="row wrap"
        fxFlex="100%;"
        fxLayout.xs="row wrap"
        fxLayoutAlign="center center"
      >
        <div
          class="energy-chart"
          fxFlex="40%;"
          fxFlex.xs="45%"
          fxFlex.sm="45%"
          [chart]="totalEnergyConsumptionChart"
        ></div>
        <div
          class="dashboard-total-energy-consumption"
          fxFlex="60%"
          fxFlex.xs="55%"
          fxLayout="column wrap"
          fxFlex.sm="55%"
          fxLayoutAlign="left left"
        >
          <span class="chart-title">{{
            'energy.dashboard.totEnergyConsump' | translate
          }}</span>
          <span class="chart-value">{{ totalEnergyConsumptionValue }}</span>
          <span class="shift-info">
            <div
              class="row"
              style="
                display: flex;
                flex-wrap: wrap;
                flex: 100%;
                justify-content: space-between;
                align-items: flex-start;
              "
            >
              <div
                class="col-md-6"
                style="
                  padding-left: 0 !important;
                  padding-right: 0 !important;
                  display: flex;
                  flex-direction: column;
                "
              >
                <div
                  *ngFor="
                    let energyConsumptionCategory of energyConsumptionCategories
                  "
                  style="margin-bottom: 10px"
                >
                  <span class="chart-title">{{
                    energyConsumptionCategory | translate
                  }}</span>
                  <button
                    class="info-box"
                    matTooltip="{{
                      firstShiftName === energyConsumptionCategory
                        ? firstShiftTime
                        : secondShiftTime
                    }}"
                    matTooltipShowDelay="500"
                    matTooltipPosition="right"
                    aria-label="Show shift start and end times"
                  >
                    i
                  </button>
                </div>
              </div>
              <div
                class="col-md-6"
                style="display: flex; flex-direction: column; flex: 50%"
              >
                <div
                  *ngFor="let energyConsumptionValue of energyConsumptionValues"
                  style="
                    margin-bottom: 10px;
                    display: flex;
                    flex-wrap: wrap;
                    flex: 100%;
                    width: 100%;
                  "
                >
                  <span class="chart-value"
                    >{{ energyConsumptionValue | number : '1.0-0' }} kWh</span
                  >
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div
      class="dashboard-wrapper energy-sourcing-container"
      fxLayout="row wrap"
      fxFlex="39.5%;"
      fxFlex.xs="100%;"
      fxFlex.lt-xl="100%;"
    >
      <div
        class="header-title header-title-hover"
        id="energy-supply"
        fxFlex="90%;"
        fxLayoutAlign="left center"
        (click)="onEnergyTrendClick()"
      >
        {{ 'energy.dashboard.energySourcing' | translate }}
      </div>
      <button
        class="info-box"
        matTooltip="{{ energySourcingTooltip }}"
        matTooltipShowDelay="500"
        matTooltipPosition="right"
        aria-label="{{ energySourcingTooltip }}"
      >
        i
      </button>
      <div
        class="chart-container"
        fxLayout="row wrap"
        fxFlex="100%;"
        fxLayout.xs="row wrap"
        fxLayoutAlign="center center"
      >
        <div
          class="energy-chart"
          fxFlex="40%;"
          fxFlex.xs="45%"
          fxFlex.sm="45%"
          [chart]="energySourcingChart"
        ></div>
        <div
          class="total-energy-sources"
          fxFlex="60%"
          fxFlex.xs="55%"
          fxLayout="column wrap"
          fxFlex.sm="55%"
          fxLayoutAlign="left left"
        >
          <span class="chart-title">{{
            'energy.dashboard.totalEnergySour' | translate
          }}</span>
          <span class="chart-value">{{ totalEnergySourcingValue }}</span>
          <span class="shift-info">
            <div
              class="row"
              style="
                display: flex;
                flex-wrap: wrap;
                flex: 100%;
                justify-content: space-between;
                align-items: flex-start;
              "
            >
              <div
                class="col-md-6"
                style="
                  padding-left: 0 !important;
                  padding-right: 0 !important;
                  display: flex;
                  flex-direction: column;
                "
              >
                <div
                  *ngFor="
                    let energySourcingCategory of energySourcingCategories
                  "
                  style="margin-bottom: 10px"
                >
                  <span class="chart-title">{{
                    energySourcingCategory | translate
                  }}</span>
                  <button
                    class="info-box"
                    matTooltip="{{
                      firstShiftName === energySourcingCategory
                        ? firstShiftTime
                        : secondShiftTime
                    }}"
                    matTooltipShowDelay="500"
                    matTooltipPosition="right"
                    aria-label="Show shift start and end times"
                  >
                    i
                  </button>
                </div>
              </div>
              <div class="col-md-6">
                <div
                  *ngFor="let energySourcingValue of energySourcingValues"
                  style="
                    margin-bottom: 10px;
                    display: flex;
                    flex-wrap: wrap;
                    flex: 100%;
                    width: 100%;
                  "
                >
                  <span class="chart-value"
                    >{{ energySourcingValue | number : '1.0-0' }} kWh</span
                  >
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div
      class="date-picker"
      fxLayout="row wrap"
      fxFlex="19%;"
      fxFlex.xs="100%;"
      fxFlex.lt-xl="100%;"
    >
      <input
        class="dashboard-datepicker"
        type="text"
        ngxDaterangepickerMd
        [(ngModel)]="dateRange"
        [showCustomRangeLabel]="true"
        [alwaysShowCalendars]="true"
        [ranges]="ranges"
        [linkedCalendars]="true"
        [showClearButton]="true"
        (ngModelChange)="onChangeDateRange()"
        (datesUpdated)="datesUpdated($event)"
        [locale]="{ format: 'YYYY-MM-DD' }"
      />
      <div
        class="dashboard-wrapper dashboard-loss"
        fxFlex="100%;"
        fxLayout="row wrap"
      >
        <div class="header-title" id="energy-loss">
          {{ 'energy.dashboard.energyLoss' | translate }}
          <span class="header-title-sub">{{
            'energy.dashboard.electricEnergy' | translate
          }}</span>
          <button
            class="info-box"
            matTooltip="{{ energyLossTooltip }}"
            matTooltipShowDelay="500"
            matTooltipPosition="right"
            aria-label="{{ energyLossTooltip }}"
            style="float: right"
          >
            i
          </button>
        </div>
        <div class="loss-info">
          <div class="row energy-loss-row">
            <div class="col-md-6 energy-loss-col">
              <img
                class="loss-icon"
                src="./assets/img/dashboard/supplied-icon.png"
                alt="Supplied"
              />
              &nbsp;
              <span class="chart-title">{{
                'energy.dashboard.supplied' | translate
              }}</span>
            </div>
            &nbsp;&nbsp;
            <div class="col-md-6">
              <span class="chart-value"
                >{{ energyloss.supplied | number : '1.0-0' }}kWh</span
              >
            </div>
          </div>
          <div class="row energy-loss-row">
            <div class="col-md-6 energy-loss-col">
              <img
                class="loss-icon"
                src="./assets/img/dashboard/loss-icon.png"
                alt="Loss"
              />
              &nbsp;
              <span class="chart-title">{{
                'energy.dashboard.loss' | translate
              }}</span>
            </div>
            <div class="col-md-6">
              <span class="loss-value"
                >{{ energyloss.loss | number : '1.0-0' }}kWh</span
              >
            </div>
          </div>
          <div class="row energy-loss-row">
            <div class="col-md-6 energy-loss-col">
              <img
                class="loss-icon"
                src="./assets/img/dashboard/meter-icon.png"
                alt="Metered"
              />
              &nbsp;
              <span class="chart-title">{{
                'energy.dashboard.metered' | translate
              }}</span>
            </div>
            <div class="col-md-6">
              <span class="meter-value"
                >{{ energyloss.metered | number : '1.0-0' }}kWh</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    id="chart-container-wrap"
    fxLayout="row wrap"
    fxFlex="100%;"
    fxLayout.xs="row wrap"
  >
    <div
      id="chartContainer"
      class="dashboard-wrapper"
      fxLayout="row wrap"
      fxFlex="49%;"
      fxFlex.lt-xl="100%;"
    >
      <div
        id="demand-trend"
        fxFlex="100%;"
        fxLayout="row wrap"
        fxLayoutAlign="space-between left"
      >
        <div fxFlex="90%;" id="demand-trend-title">
          <span class="header-title" id="demand-supply">{{
            'energy.dashboard.demandTrendTitle' | translate
          }}</span>
        </div>
        <button
          class="info-box"
          matTooltip="{{ demandSupplyTooltip }}"
          matTooltipShowDelay="500"
          matTooltipPosition="right"
          aria-label="{{ demandSupplyTooltip }}"
        >
          i
        </button>
      </div>
      <div
        id="demand-supply-trends-chart"
        fxLayout="row wrap"
        fxFlex="100%;"
        [chart]="demandSupplyTrendsChart"
      ></div>
    </div>
    <div
      class="dashboard-wrapper"
      id="dash-energy-consumption-top"
      fxLayout="row wrap"
      fxFlex="49%;"
      fxFlex.lt-xl="100%;"
    >
      <div
        id="energy-consumption-top"
        fxFlex="100%;"
        fxLayout="row wrap"
        fxLayoutAlign="space-between left"
      >
        <div class="header-title" id="top-energy-consumers" fxFlex="90%;">
          {{ 'energy.dashboard.topEnergyConsum' | translate }}
        </div>
        <button
          class="info-box"
          matTooltip="{{ topEnergyConsumTooltip }}"
          matTooltipShowDelay="500"
          matTooltipPosition="right"
          aria-label="{{ topEnergyConsumTooltip }}"
        >
          i
        </button>
      </div>
      <div
        id="chart-top-energy-consumers"
        fxLayout="row wrap"
        fxFlex="100%;"
        [chart]="topEnergyConsumersChart"
      ></div>
    </div>
  </div>
</div>
